import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function G() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('solar_panel_175w');
    const { locale } = useRouter();

    const IMGS = [
        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125218348/7_1.jpg',
        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125228505/7_2.jpg',
    ];

    return (
        <div className={`sp-175w-G sp-175w-common ${css['sp-175w-G']}`}>
            <ul className="items">
                {[1, 2]?.map((item: any, k: number) => (
                    <li className="item" key={k}>
                        <div className="info">
                            <p className="subtitle">{t(`G_item${item}_subtitle`)}</p>
                            <p className="title">{t(`G_item${item}_title`)}</p>
                            <p className="desc">{t(`G_item${item}_desc`)}</p>
                        </div>
                        <div className="item-img">
                            <EFPicture src={IMGS[k]} alt={t(`G_item${item}_title`)} />
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}
